
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/manage-subscriptions",
      function () {
        return require("private-next-pages/profile/manage-subscriptions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/manage-subscriptions"])
      });
    }
  